<template>
  <div id="app">
    <!-- <img alt="Vue logo" src="./assets/logo.png">
    <AButton type="primary">Button</AButton>
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    <ALayout class="ant-layout">
      <AHeader class="ant_header">
        <a-row>
          <a-col :span="6" class="top_logo">
            <a href="/" class="">
              <img :src="$store.state.check.logoUrl" alt="" />
              <!-- <ADivider type="vertical" v-if="$store.state.check.logoUrl" /> -->
              <!-- <img src="./assets/images/logo_03.png" alt="" />  -->
            </a>
          </a-col>
          <a-col :span="12" :offset="6" class="top_right">
            <!-- <div class="topMenu"> -->
            <AMenu class="top_menu" mode="horizontal" :selectedKeys="[$route.path]">
              <AMenuItem
                v-for="item in routes"
                :key="item.path"
              >
                <!-- <a :href="item.path"> {{ item.breadcrumbName }}</a> -->
                <a v-if="item.path==='/demo'" target="_blank" href="http://cdn.wfcheck.cn/demo/报告样例（全文详情）.html">
                  {{ item.breadcrumbName }}
                </a>
                <router-link v-else :to="item.path">{{ item.breadcrumbName }}</router-link>
              </AMenuItem>
            </AMenu>
            <!-- </div> -->
          </a-col>
        </a-row>
      </AHeader>
      <AContent class="ant_content">
        <div class="basic-content">
          <router-view></router-view>
          <div class="content-img">
            <div>
              <a
                href="#"
                rel="sidebar"
                @click="addFavorite"
                title="收藏本站到收藏夹"
                ><img src="./assets/images/sc.png" alt=""
              /></a>
            </div>
            <div>
              <a :href="$store.state.check.userProduct.qrCodeUrlPath" target="_blank"><img src="./assets/images/lx.png" alt=""
              /></a>
            </div>
            <div>
              <router-link to="/questions"
                ><img src="./assets/images/cj.png" alt=""
              /></router-link>
            </div>
          </div>
        </div>
      </AContent>
      <AFooter class="ant_footer">
        
        <span>{{this.$store.state.check.userProduct.title}}</span> ｜
        <a-icon type="copyright" class="copyright" />
        北京万方数据股份有限公司 广东万方数据信息科技有限公司 粤ICP备20046369号
      </AFooter>
    </ALayout>
  </div>
</template>

<script>
import { Layout, Row, Col, Menu, Icon } from 'ant-design-vue'
// import HelloWorld from './components/HelloWorld.vue'
// import { Button } from 'ant-design-vue';
export default {
  name: 'App',
  components: {
    // HelloWorld,
    // AButton: Button,
    ALayout:Layout,
    AHeader:Layout.Header,
    AContent:Layout.Content,
    AFooter:Layout.Footer,
    ARow:Row,
    ACol:Col,
    AMenu:Menu,
    AMenuItem:Menu.Item,
    // ADivider:Divider,
    AIcon:Icon
  },
    data () {
      return {
        routes: [
        {
          path: '/home',
          breadcrumbName: '首页',
        },
        {
          path: '/down',
          breadcrumbName: '下载报告',
        },
        {
          path: '/demo',
          breadcrumbName: '报告演示',
        },
        {
          path: '/more',
          breadcrumbName: '系统介绍',
        },
        {
          path: '/questions',
          breadcrumbName: '常见问题',
        },
      ],
      }
    },
    created () {
      this.$store.dispatch('check/getUserProduct', {
        payload: {
          product: this.$route.params.product
        }
      })
      this.$store.dispatch('check/getLogo', {
       
      })
    },
    methods: {
      addFavorite () {
        var url = window.location;
        var title = document.title;
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("360se") > -1) {
          this.$message.info('由于360浏览器功能限制，请按 Ctrl+D 手动收藏！');
        }
        else if (ua.indexOf("msie 8") > -1) {
          window.external.AddToFavoritesBar(url, title); //IE8
        }
        else if (document.all) {//IE类浏览器
          try {
            window.external.addFavorite(url, title);
          } catch (e) {
            this.$message.info('您的浏览器不支持，请按 Ctrl+D 手动收藏！');
          }
        }
        else if (window.sidebar) {//firfox等浏览器；
          window.sidebar.addPanel(title, url, "");
        }
        else {
          this.$message.info('您的浏览器不支持，请按 Ctrl+D 手动收藏！');
        }
      }
    }
}
</script>

<style lang="less" scoped>
body {
    background-color: #e6e6e6 !important;
    line-height: 1.42857143;
    margin: 0;
    padding: 0;
  }
#app {
  // width:1200px;
  padding: 0;
  margin: 0;
  height:100%;
  display:flex;
  flex-direction:column;
}

.ant_header{
  flex: 0 0 auto;
  margin: 0 10%;
  background-color: #fff;
  height:80px;
  line-height: 80px;
  padding:0;
  .top_logo{
    // margin-left: 10%;
    text-align: left;
    img {
      // width: 350px;
      height:68px;
    }
  }

  .top_menu {
    // height:80px;
    // line-height: 80px;
    margin-top:17px;
    text-align:right;
    a {
      color: #8e8e8e;
    }
  }
  }

.ant-menu-horizontal{
  border: none;
}
.ant_content {
  flex: 1 0 auto;
  .content-img {
      position: fixed;
      top: 35%;
      right: 3%;
      img {
        border: 1px solid #ededed;
        margin-bottom: 10px;
      }
    }
}
.ant_footer {
  flex: 0 0 auto;
  height: 80px;
  line-height: 80px;
  margin-top: 20px;
  text-align: center;
  background-color: rgb(34, 105, 190);
  color: #fff;
  font-weight: 500;
}


.ant-layout-footer{
  padding:0;
}

</style>
